import { createAction, props } from '@ngrx/store';
import { PaginationState } from '@shared/models/pagination-state';
import { Sorting } from '@shared/models/sorting';
import { Group } from '@shared/models/group';
import { GroupFilters } from '@shared/models/group-filters';

export const loadGroupDuplicates = createAction(
  '[Groups] Load Group Duplicates',
  props<{
    paginationState: PaginationState;
    filters: GroupFilters;
    sorting: Sorting;
  }>(),
);

export const loadGroupDuplicatesSuccess = createAction(
  '[Groups] Load Group Duplicates Success',
  props<{
    data: Group[];
    paginationState: PaginationState;
    filters: GroupFilters;
    sorting: Sorting;
  }>(),
);

export const loadGroupDuplicatesFailure = createAction(
  '[Groups] Load Group Duplicates Failure',
  props<{ error: any }>(),
);
